import { assignWith } from 'lodash';

const isUndefined = (value?: number | string | {}) => value == null;

const mergeProps = (ownProps: any, contextProps: any) =>
  assignWith(
    { ...ownProps },
    contextProps,
    (ownPropValue, contextValue, key = '') => {
      if (
        !isUndefined(contextValue) &&
        (key.startsWith('on') || isUndefined(ownPropValue))
      ) {
        return contextValue;
      }

      return ownPropValue;
    },
  );

export default mergeProps;
